import BgMusicConfig from "./BgMusicConfig/BgMusicConfig";
import '@/pages/VideoClips/MixCutDetail/BgConfig/BgConfig.less'
import React from "react";
import { observer } from "mobx-react";
const BgConfig = () => {
  return (
    <>
      <BgMusicConfig />
    </>
  );
};

export default observer(BgConfig);
